// extracted by mini-css-extract-plugin
module.exports = {"btnPrimary":"Button_btnPrimary__3rWEa","btnLight":"Button_btnLight__2r6Pj","btnDrk":"Button_btnDrk__K9U2r"};